import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

export const Paciente = (props) => {
	/* Destructuring the props object. */
	const {
		fotoUsuario,
		nombreUsuario,
		idUsuario,
		direccionUsuario,
		telefonoUsuario,
		codPostUsuario,
		ShareCare,
		abrirPerfil,
	} = props;

	/* A hook that is used to set the state of the component. */
	const [ColorShareCare, setColorShareCare] = useState('ShareCareVerde');

	/* A hook that is used to set the state of the component. */
	useEffect(() => {
		ShareCare === 'Activo'
			? setColorShareCare('ShareCareVerde')
			: setColorShareCare('ShaCareRojo');
	}, []);

	return (
		<>
			<div
				className='Paciente-admin'
				onClick={() => abrirPerfil(idUsuario)}
			>
				<div className='fotoUsuario centrador'>
					<div className='fotoNombreUsuario'>
						<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
					</div>
					<div className='nombreIdUsuario '>
						<div className='nombreUsuario'>{nombreUsuario}</div>
						{/*<div className='idUsuario'><b>ID : </b>{idUsuario}</div>*/}
					</div>
				</div>
				<div className='datosUsuario'>
					<div className='direccionUsuario'>
						<b>Dirección : </b>
						{direccionUsuario}
					</div>
					<div className='telefonoUsuario'>
						<b>Teléfono : </b>
						{telefonoUsuario}
					</div>
				</div>
				<div className='datosUsuario'>
					<div className='correoUsuario'>
						<b>Cod. postal : </b>
						{codPostUsuario}
					</div>
					{/* <div className='telefonoUsuario'>
						<b>ShareCare : </b>
						<b className={ColorShareCare}>{ShareCare}</b>
					</div> */}
				</div>
			</div>
		</>
	);
};
